/** Version strings for clickwrap consent — bump when legal copy changes materially. */
export const LEGAL_VERSIONS = {
  terms: '2026-07-25',
  privacy: '2026-07-27',
  refunds: '2026-10-12',
  sellerAgreement: '2026-07-25',
  communityGuidelines: '2026-07-25',
  cookiePolicy: '2026-07-25',
} as const;

export type LegalDocKey = keyof typeof LEGAL_VERSIONS;

export const LEGAL_CONTACT = {
  email: 'hello@makhestudents.co.za',
  supportWhatsApp: 'https://wa.me/27700000000',
  companyName: 'Makhe Technologies (Pty) Ltd',
  informationOfficer: 'Nompumelelo Madonsela',
} as const;

export function isLegalConsentCurrent(
  consent: { termsVersion: string; privacyVersion: string } | undefined | null,
): boolean {
  if (!consent) return false;
  return (
    consent.termsVersion === LEGAL_VERSIONS.terms &&
    consent.privacyVersion === LEGAL_VERSIONS.privacy
  );
}
